import { useContext, useEffect, useState } from 'react';

import { useLocation } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import RemoveModal from '../../../Components/Modal/RemoveModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { AgeContext } from '../Context/AgeContext';

const Age = () => {
  const context = useContext(AgeContext);
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getAges();
    };
    getData();
  }, [search]);

  const getAges = async () => {
    setLoading(true);
    await get(
      `/age${search}`,
      (res) => {
        context.ages = res;
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const removeItem = async (id) => {
    setRemoveLoading(true);

    await destroy(
      `/age/${id}`,
      (res) => {
        success(`رده سنی "${modalRemoveObject?.title}" با موفقیت حذف شد.`);
        setRemoveLoading(false);
        setModalIsOpen(false);
        getAges();
      },
      (err) => {
        error('حذف به علت خطا انجام نشد.');
        setRemoveLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title='لیست رده های سنی'
          createBtnTitle='ایجاد رده سنی'
          createPath='/age/create'
        />
        <Datatable
          data={context.ages?.data}
          editUrl='/age/edit'
          meta={context.ages?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePagePath='/age'
          columns={['عنوان', 'شروع رده سنی', 'پایان رده سنی']}
          rows={[
            { name: 'title', type: 'string' },
            { name: 'start_age', type: 'date' },
            { name: 'end_age', type: 'date' },
          ]}
        />
      </Master>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeItem}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف رده سنی "${modalRemoveObject?.title}" مطمئن هستید ؟`}
      />
    </>
  );
};

export default Age;
